import {Injectable} from "@angular/core";
import {AbstractSQLService} from "./AbstractSQLService";
import {Comportamento} from "../../../domain/Comportamento";

@Injectable()
export class ComportamentoSQLService extends AbstractSQLService<Comportamento>{
    nomeTabela = "comportamento"
  agenciavel = false
}
